import dutchLang from 'element-ui/lib/locale/lang/nl'
const messages = {
  ...dutchLang,
  "banner1": "Solplanet is een merk van en ontwikkeld door AISWEI",
  "banner2": "voorheen SMA China",
  "banner3": "Zonne-energie voor iedereen",
  "english": "Engels",
  "polish": "Pools",
  "spanish": "Spanish",
  "turkish": "Turks",
  "germany": "Duits",
  "french": "Frans",
  "italian": "Italiaans",
  "systemData1": "systeem",
  "installationLocation1": "installatie",
  "customerData1": "klant",
  "claimData": "claim",
  "shippingAddress1": "verzending",
  "customerData": "Klant/klantgegevens",
  "customerType": "Soort aanvrager",
  "selectCustomer": "Selecteer het soort aanvrager",
  "--None--": "--Geen--",
  "Installer": "Installateurs",
  "End-customer": "Eindklanten",
  "Distributor": "Distributeur",
  "EPC": "EPC",
  "Other": "Andere",
  "companyName": "Bedrijfsnaam",
  "typeCompanyName": "Vul een bedrijfsnaam in",
  "contacts": "Contactnaam",
  "typeContacts": "Vul een contactnaam in",
  "contactInformation": "Telefoonnummer",
  "typeContactInformation": "Vul een telefoonnummer in",
  "shippingAddress": "Verzendadres (dit adres wordt in geval van omruiling gebruikt als verzendadres).",
  "country": "Land/Regio",
  "typeCountry": "Vul de naam van het land/regio in",
  "province": "Staat/provincie",
  "typeProvince": "Vul de naam van de staat/provincie in",
  "city": "Stad",
  "typeCity": "Vul de naam van de stad in",
  "area": "Straat",
  "typeArea": "Voer het volledige adres in (tot aan het huisnummer toe)",
  "contacts01": "Mobiele telefoon",
  "typeContacts01": "Vul een mobiel telefoonnummer in",
  "postCode": "Postcode",
  "typePostCode": "Vul een postcode in",
  "email": "E-mail",
  "typeEmail": "Vul een e-mailadres in",
  "errorEmail": "Gelieve een geldig e-mailadres in te geven.",
  "installationLocation": "Installatielocatie (gebruik het verzendadres)",
  "purchaseDate": "Aankoopdatum",
  "typePurchaseDate": "Vul dit in Aankoopdatum",
  "installDate": "Installatiedatum",
  "typeInstallDate": "Vul dit in Installatiedatum",
  "faultyDeviceType": "Type apparaatfout",
  "selectFaultyDeviceType": "Maak een keuze   Type apparaatfout",
  "faultDate": "Foutdatum",
  "typeFaultDate": "Vul dit in Foutdatum",
  "deviceSerialNumber": "Serienummer apparaat",
  "typeDeviceSerialNumber": "Vul dit in Serienummer apparaat",
  "faultySymptom": "Symptoom fout",
  "selectFaultySymptom": "Maak een keuze  Symptoom fout",
  "errorDescription": "Gedetailleerde foutomschrijving",
  "typeErrorDescription": "Vul een gedetailleerde foutbeschrijving in",
  "purchaseFileId": "Aankoopbon (bijlage)",
  "purchaseDesc": "(Het aankoopbewijs moet de naam van de klant, het installatie-adres en het model van de omvormer bevatten, en aangeven dat ervoor betaald is)",
  "breakFileId": "Storingscertificaat (bijlage)",
  "breakDesc": "(Stuur een foto op met de details van het defect, de foutmelding en de sticker met het serienummer van het product)",
  "upload": "Uploaden",
  "systemData": "Systeemgegevens (optioneel)",
  "systemData01": "Is dit de eerste claim van deze locatie",
  "Yes": "Ja",
  "No": "Nee",
  "Unknown": "Niet bekend",
  "systemData02": "Status van andere omvormers die op dezelfde locatie in bedrijf zijn",
  "systemData03": "Reden voor eerdere claim",
  "enterSystemData03": "Vul dit in Reden voor eerdere claim",
  "systemData04": "Detail van defect(en) van andere omvormers op dezelfde locatie",
  "enterSystemData04": "Vul dit in Detail van defect(en) van andere omvormers op dezelfde locatie",
  "systemData05": "Omgevingsomstandigheden omvormerinstallatie",
  "systemData0501": "Interieur",
  "systemData0502": "Exterieur (aan de schaduwkant van het gebouw of onder een afdak of luifel)",
  "systemData0503": "Exterieur (waarbij de omvormer blootgesteld is aan direct zonlicht)",
  "systemData0504": "Boven water",
  "systemData0505": "Overig",
  "systemData06": "Omgevingsomstandigheden zonnepanelen-installatie",
  "systemData0601": "Op de grond",
  "systemData0602": "Op het dak",
  "systemData0603": "Op het wateroppervlak",
  "systemData0604": "Overig",
  "systemData07": "Merk en model van het/de zonnepaneel/zonnepanelen",
  "typeSystemData07": "Vul dit in Merk en model van het/de zonnepaneel/zonnepanelen",
  "systemData08": "FV-model",
  "systemData0801": "Onafhankelijk",
  "systemData0802": "Parallel",
  "pleaseSelect": "Maak een keuze",
  "add": "Toevoegen",
  "delete": "Verwijderen",
  "pv10": "string-zonnepaneel (stuks)",
  "pv101": "FV1-string-zonnepaneel (stuks)",
  "pv102": "FV2-string-zonnepaneel (stuks)",
  "pv103": "FV3-string-zonnepaneel (stuks)",
  "pv104": "FV4-string-zonnepaneel (stuks)",
  "circuit01": "nullastspanning (V)",
  "alternatingVoltage": "Wisselstroom (AC)",
  "l1l2": "Wisselstroom L1 - L2 (V)",
  "l1n": "Wisselstroom L1 - N (V)",
  "l2l3": "Wisselstroom L2 - L3 (V)",
  "l2n": "Wisselstroom L2 - N (V)",
  "l1l3": "Wisselstroom L1 - L3 (V)",
  "l3n": "Wisselstroom L3 - N (V)",
  "l1pe": "Wisselstroom L1 - PE (V)",
  "l3pe": "Wisselstroom L3 - PE (V)",
  "l2pe": "Wisselstroom L2 - PE (V)",
  "npe": "Wisselstroom N - PE (V)",
  "complaintFileId": "Bijlage",
  "activeTip": "(Opmerking:  Hoe meer gedetailleerde informatie u ons kunt geven, des te sneller kunnen we vaststellen wat het probleem is).",
  "submitBtn": "Verzenden",
  "pleaseType": "Vul dit in",
  "submitSuccess": "Succesvol",
  "submitDesc": "Sommige verplichte velden zijn niet ingevuld, vul deze opnieuw in na de bevestiging. Bedankt!",
  "typeUpload": "Upload alstublieft",
  "resetUpload": "Reupload",
  "selectErrorMessage": "Selecteer een foutmelding",
  "errorMessage": "Anderen",
  "MPPT": "MPPT",
  "chinese": "Chinees",
  "dutch": "Nederlands",
  "hungary": "Hongaars",
  "termswebsite": "https://solplanet.net/privacy/",
  "terms": "Ik ga akkoord met de algemene voorwaarden van Solplanet",
  "iagree": "Ik ga akkoord met de algemene voorwaarden van Solplanet",
  "language": "Taal",
  "ptbr": "Portugees (Brazilië)",
  "zhtw": "Traditioneel Chinees",
  "documentTitle": "Garantie │Solplanet",
  "validateNumber": "Voer een geheel getal in"
}
export default messages



// WEBPACK FOOTER //
// ./src/widgets/i18n/dutch.js